<script>
import App from "@/pages/layouts/app.vue";
import Card from "@/pages/components/card.vue";
import Datatable from "@wielink-application/shared/js/mixins/datatable";
import {Link} from "@inertiajs/vue3";
export default {
  mixins: [Datatable],
  components: {Link, App, Card},
}
</script>

<template>
  <App title="Kennisbank">
    <template v-if="$page.props.auth.permissions.includes('manage knowledge_base')" #topButtons>
      <Link :href="route('knowledge_base.messages.create')" class="btn btn-primary me-2">
        <i class="bi bi-plus-lg"></i>
        Bericht toevoegen
      </Link>
    </template>

    <Card v-if="$page.props.auth.permissions.includes('manage knowledge_base')">
      <Table ref="table" id="messages" :config="tableConfig"/>
    </Card>
  </App>
</template>